if (!customElements.get('recipient-form')) {
  customElements.define('recipient-form', class RecipientForm extends HTMLElement {
    constructor() {
      super();
      this.checkboxInput = this.querySelector(`#Recipient-checkbox-${this.dataset.sectionId}`);
      this.recipientFields = this.querySelector('.recipient-fields');
      this.emailInput = this.querySelector(`#Recipient-email-${this.dataset.sectionId}`);
      this.nameInput = this.querySelector(`#Recipient-name-${this.dataset.sectionId}`);
      this.messageInput = this.querySelector(`#Recipient-message-${this.dataset.sectionId}`);
      this.sendOnInput = this.querySelector(`#Recipient-send-on-${this.dataset.sectionId}`);
      this.offsetField = this.querySelector(`#Recipient-timezone-offset-${this.dataset.sectionId}`);
      this.controlField = this.querySelector(`#Recipient-control-${this.dataset.sectionId}`);
      this.variantId = this.dataset.productVariantId;

      // Enable checkbox and set timezone
      this.checkboxInput.disabled = false;
      if (this.offsetField) {
        this.offsetField.value = new Date().getTimezoneOffset().toString();
      }

      // Set min date for send-on field
      if (this.sendOnInput) {
        this.sendOnInput.min = new Date().toISOString().split('T')[0];
      }

      // Bind events
      this.checkboxInput.addEventListener('change', this.onCheckboxChange.bind(this));
      this.bindErrorValidation();
      this.initializeForm();

      // Listen for variant changes
      document.addEventListener('variant:change', this.onVariantChange.bind(this));
    }

    onVariantChange(event) {
      if (event.detail.variant && event.detail.variant.id.toString() !== this.variantId) {
        this.variantId = event.detail.variant.id.toString();
        this.resetForm();
      }
    }

    bindErrorValidation() {
      if (this.emailInput) {
        this.emailInput.addEventListener('input', () => {
          this.clearError('email');
          if (this.emailInput.validity.valid) {
            this.clearError('email');
          }
        });

        this.emailInput.addEventListener('blur', () => {
          if (!this.emailInput.validity.valid && this.emailInput.value) {
            this.showError('email');
          }
        });
      }

      if (this.nameInput) {
        this.nameInput.addEventListener('input', () => {
          this.clearError('name');
        });

        this.nameInput.addEventListener('blur', () => {
          if (!this.nameInput.value && this.nameInput.required) {
            this.showError('name');
          }
        });
      }

      if (this.sendOnInput) {
        this.sendOnInput.addEventListener('input', () => {
          this.clearError('send-on');
        });

        this.sendOnInput.addEventListener('blur', () => {
          if (this.sendOnInput.value) {
            const selectedDate = new Date(this.sendOnInput.value);
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            
            if (selectedDate < today) {
              this.showError('send-on');
            }
          }
        });
      }
    }

    showError(fieldName) {
      const errorElement = this.querySelector(`[data-error="${fieldName}"]`);
      const inputElement = this.querySelector(`#Recipient-${fieldName}-${this.dataset.sectionId}`);
      if (errorElement) {
        errorElement.classList.add('active');
      }
      if (inputElement) {
        inputElement.classList.add('error');
      }
    }

    clearError(fieldName) {
      const errorElement = this.querySelector(`[data-error="${fieldName}"]`);
      const inputElement = this.querySelector(`#Recipient-${fieldName}-${this.dataset.sectionId}`);
      if (errorElement) {
        errorElement.classList.remove('active');
      }
      if (inputElement) {
        inputElement.classList.remove('error');
      }
    }

    onCheckboxChange() {
      if (this.checkboxInput.checked) {
        this.enableForm();
      } else {
        this.disableForm();
      }
    }

    resetForm() {
      this.checkboxInput.checked = false;
      this.onCheckboxChange();
    }

    initializeForm() {
      this.controlField.disabled = true;
      this.onCheckboxChange();
    }

    enableForm() {
      this.recipientFields.style.display = 'block';
      this.controlField.value = 'true';
      
      [this.emailInput, this.nameInput, this.messageInput, this.sendOnInput].forEach(input => {
        if (input) {
          input.disabled = false;
        }
      });
    }

    disableForm() {
      this.recipientFields.style.display = 'none';
      this.controlField.value = '';
      
      [this.emailInput, this.nameInput, this.messageInput, this.sendOnInput].forEach(input => {
        if (input) {
          input.value = '';
          input.disabled = true;
          if (input.classList.contains('error')) {
            input.classList.remove('error');
          }
        }
      });

      // Clear all error messages
      this.querySelectorAll('.field__error.active').forEach(error => {
        error.classList.remove('active');
      });
    }
  });
}
  